import React, { useEffect } from 'react';
import styles from './styles.module.scss';

function ErrorNotification({errors}) {

  useEffect(() => {

    if (errors && errors.length) {
      document.getElementById('errors').scrollIntoView();
    }
  }, [errors]);

    return (
      <div>
        {errors && errors.length > 0 && (
          <div id="errors" className={styles.errorBackground}>
            {errors.map((error, k) => (
              <div className={`${styles.errorItem} d-flex align-items-center`} key={k}>
                <img src="/image/error-icon.svg" className="mr-2" width="16" height="16" alt="Error" />
                {`${error}`}
              </div>
            ))}
          </div>
        )}
      </div>
    );
}

export default ErrorNotification;